import {useState} from 'react';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import EnergySlider from '../components/EnergySlider/EnergySlider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useProfilePrograms } from '../../../hooks/useProfilePrograms';


const ProgramModal = ({ open, onClose }) => {
  const [programData, setProgramData] = useState({
    scheduleName: '',
    programStartDate: '',
    programEndDate: '',
    phase1hoursel: dayjs().hour(0).minute(0),
    sliderPhase1: 1,
    phase2hoursel: dayjs().hour(0).minute(0),
    sliderPhase2: 1,
    phase3hoursel: dayjs().hour(0).minute(0),
    sliderPhase3: 1,
    phase4hoursel: dayjs().hour(0).minute(0),
    sliderPhase4: 1,
  });
  
  const handleChange = (field, value) => {
    setProgramData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const { addNewProgram } = useProfilePrograms([], false);

  const handleSubmit = () => {
    addNewProgram(programData);
    onClose(); 
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Στοιχεία Προγράμματος</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={3} mt={1}>
          <TextField
            label="Όνομα Προγράμματος"
            fullWidth
            value={programData.scheduleName}
            onChange={(e) => handleChange('scheduleName', e.target.value)}
          />

        {[1, 2, 3, 4].map((phase) => (
          <Box key={phase}>
            <TimePicker
              label={`Ώρα Εκκίνησης Φάσης ${phase}`}
              views={['hours']}
              ampm={false}
              value={programData[`phase${phase}hoursel`]}
              onChange={(value) => handleChange(`phase${phase}hoursel`, value)}
              slotProps={{ textField: { fullWidth: true } }}
            />

            <Box mt={2}>
              <Typography gutterBottom>
                Επίπεδο Φωτισμού Φάσης {phase}: {programData[`sliderPhase${phase}`]}%
              </Typography>
              <EnergySlider
                value={programData[`sliderPhase${phase}`]}
                onChange={(_, value) =>
                 handleChange(`sliderPhase${phase}`, value)
                }
              />
            </Box>
          </Box>
        ))}

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Ακύρωση</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Αποθήκευση
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProgramModal;